import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconStop = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5714 6.05714H7.42857C6.67115 6.05714 6.05714 6.67115 6.05714 7.42857V16.5714C6.05714 17.3288 6.67115 17.9429 7.42857 17.9429H16.5714C17.3288 17.9429 17.9429 17.3288 17.9429 16.5714V7.42857C17.9429 6.67115 17.3288 6.05714 16.5714 6.05714ZM7.42857 4C5.53502 4 4 5.53502 4 7.42857V16.5714C4 18.465 5.53502 20 7.42857 20H16.5714C18.465 20 20 18.465 20 16.5714V7.42857C20 5.53502 18.465 4 16.5714 4H7.42857Z"
        />
      </svg>
    );
  }
);
